exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide .container[data-v-6685e442]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:89px;color:#da3800;background-color:#f1f1f16e}.icon[data-v-6685e442]:hover{color:#191919;background-color:#442020}.close-guide[data-v-6685e442]{position:absolute;top:0;right:0}.guide-text[data-v-6685e442]{position:absolute;top:22px;right:20px;max-width:150px;font-size:12px}@media (max-width: 767px){.guide-text[data-v-6685e442]{top:35px;right:0px;font-size:10px}}\n", ""]);

// exports
